import RoutesMap from "../../route_control/RouteControl"
import {
    AddCompany,
    CompanyList,
    UpdateCompany,
    AddCompanyUser,
    CompanyUserList,
    UpdateCompanyUser
} from "../../pages/superAdmin"

export const SuperAdminRouteImport = {
    RoutesMap,
    AddCompany,
    CompanyList,
    UpdateCompany,
    AddCompanyUser,
    CompanyUserList,
    UpdateCompanyUser,
}

